<template>
  <div id="app">
    <Header />
    <router-view></router-view>
    <Footer
      :showFooter="showFooter()"
    />
  </div>
</template>

<script>
import Header from '@/components/Header.vue';
import Footer from '@/components/Footer.vue';

export default {
  name: 'App',
  components: {
    Header,
    Footer,
  },
  data() {
    return {
      //
    }
  },
  methods: {
    showFooter() {
      if(this.$router.currentRoute.name === 'Home' || this.$router.currentRoute.name === 'Error') {
        return false;
      }
      return true;
    },
  }
}
</script>

<style lang="scss">
#app {
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
}
</style>
